import { Button, Popconfirm } from "antd";
import React from "react";
import { COLORS } from "../pages/theme";
import GroupedUnreconciledCardExpandedItem from "./grouped_unreconciled_card_expanded_item";

const GroupedUnreconciledCardExpandedColumn = ({
    isOurs,
    items,
    selected,
    reference,
    onSelect,
    showTransactionModal,
    idx,
}) => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: 8,
                flex: 1,
            }}
        >
            <div
                style={{
                    alignSelf: !isOurs && "end",
                }}
            >
                {isOurs && "OURS"}
                <span style={{ color: COLORS.primary, margin: 8 }}>
                    {reference}
                </span>
                {!isOurs && "THEIRS"}
            </div>
            {items.map((item) => (
                <GroupedUnreconciledCardExpandedItem
                    idx={idx}
                    item={item}
                    isOurs={isOurs}
                    selected={selected}
                    onSelect={onSelect}
                    showTransactionModal={showTransactionModal}
                />
            ))}
        </div>
    );
};

export default function GroupedUnreconciledCardExpanded({
    idx,
    ours,
    theirs,
    reference,
    onReconcile,
    onReconcileAll,
    showTransactionModal,
    selectedItems,
    setSelectedItem,
    spinning,
    spinningAll,
}) {
    const selectedOur = selectedItems?.[idx]?.ours;
    const selectedTheir = selectedItems?.[idx]?.theirs;

    return (
        <div style={{ padding: 20 }}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 60,
                }}
            >
                {[0, 1].map((i) => {
                    const isOurs = i === 0;
                    return (
                        <GroupedUnreconciledCardExpandedColumn
                            idx={idx}
                            selected={isOurs ? selectedOur : selectedTheir}
                            isOurs={isOurs}
                            items={isOurs ? ours : theirs}
                            reference={
                                isOurs
                                    ? reference?.our_data_type_id?.name
                                    : reference?.their_data_type_id?.name
                            }
                            onSelect={setSelectedItem}
                            showTransactionModal={showTransactionModal}
                            setSelectedItems={setSelectedItem}
                            selectedItems={selectedItems}
                        />
                    );
                })}
            </div>
            <div style={{ textAlign: "center", marginTop: 40 }}>
                <Button
                    style={{ border: "none" }}
                    disabled={!(selectedOur && selectedTheir)}
                    type="primary"
                    onClick={() => onReconcile(idx)}
                    loading={spinning}
                >
                    RECONCILE ITEMS
                </Button>
                {ours.length === theirs.length && (
                    <Popconfirm
                        title="Are you sure you want to reconcile all data of this card?"
                        onConfirm={() => onReconcileAll(idx)}
                        // onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button
                            style={{ border: "none", marginLeft: 20 }}
                            type="danger"
                            loading={spinningAll}
                        >
                            RECONCILE ALL
                        </Button>
                    </Popconfirm>
                )}
            </div>
        </div>
    );
}
